export enum Token {
  AccessToken = "AccessToken",
  RefreshToken = "RefreshToken",
}
